import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/fr/og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout, showAskUsAnything: true },
  seo: {
    title: 'Notre présence en Europe et aux États-Unis | Assurance Lemonade',
    metaTitle: 'Notre présence en Europe et aux États-Unis | Assurance Lemonade',
    description:
      "Découvrez où en Europe et aux États-Unis Lemonade vous offre une assurance boostée par l'intelligence artificielle et basée sur l'impact social ✨",
    ogImage: og.src,
  },
  hero: {
    title: 'Soyez les premiers\ninformés !',
    subtitle: `Nous sommes disponibles à travers l'Europe et les <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/">États-Unis</a>\nLaissez-nous votre email pour être informé lorsque nous arriverons chez vous.`,
  },
  MDXContent: content as DocumentTypes,
};
